import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {Modal} from '../../data/modal';
import {DatePickerComponent} from '../../../../components/picker/date-picker/date-picker.component';
import {I18nModule} from '../../../../i18n/i18n.module';

import { DateService, IsoDate, IsoDateTime } from '@softline/core';

@Component({
    selector: 'soft-date-input-dialog',
    templateUrl: './date-picker-modal.component.html',
    styleUrls: ['./date-picker-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
    DatePickerComponent,
    I18nModule
],
    providers: []
})
export class DatePickerModalComponent implements Modal<IsoDate | null> {

  dateService = inject(DateService);
  today = this.dateService.now();

  title?: string;
  subtitle?: string;
  value: string | null = null

  close!: (result: IsoDate | null) => void;

  registerCloseHandler(handler: (result: (IsoDate | null)) => void) {
    this.close = handler;
  }
}
